// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1vn21","modalForm":"UpgradeEpcsModal_modalForm__3Ab83","modalFooter":"UpgradeEpcsModal_modalFooter__3BgGL"};